module.exports = __webpack_public_path__ + "img/5.e8807473.png";